import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router";
import { AgroManagerEnvironmentHandler } from "../../../../API/agromanager/agromanager";
import { AgroManagerIdentityHandler } from "../../../../API/agromanager/agromanager";

export default function AgroManagerCallbackHandler() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const agroManagerError = params.get("error");
    const agroManagerCode = params.get("code");
    const agroManagerEnvironment = params.get("tenant");

    if (!agroManagerCode || agroManagerError) {
      navigate(`/login`, { state: { error: "flash.AgroManagerUserNotFound" } });
    } else if (agroManagerCode && agroManagerEnvironment) {
      AgroManagerEnvironmentHandler(
        agroManagerCode,
        agroManagerEnvironment,
        navigate,
      );
    } else {
      AgroManagerIdentityHandler(agroManagerCode, navigate);
    }
  }, []);
  return null;
}
